import { render, staticRenderFns } from "./bi-separator.vue?vue&type=template&id=89f8e11a&"
import script from "./bi-separator.vue?vue&type=script&lang=ts&"
export * from "./bi-separator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports